var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useState, useEffect } from 'react';
import MultiSelectFull from '../MultiSelect/Full';
import Label from '../Label';
import Instruction from '../Instruction';
import MultiSelectFullPill from '../MultiSelect/Full/Pill';
import Button from '../../Button';
import { Edit2, Plus } from 'react-feather';
import { useController } from 'react-hook-form';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
var JobsInput = function (_a) {
    var name = _a.name, control = _a.control, defaultValue = _a.defaultValue, categories = _a.categories, custom = _a.custom, handleCustom = _a.handleCustom, sorted = _a.sorted, handleSorted = _a.handleSorted;
    var _b = useState(false), drawer = _b[0], setDrawer = _b[1];
    var _c = useController({ name: name, control: control, defaultValue: defaultValue }), field = _c.field, fieldState = _c.fieldState;
    var getAllValues = function () {
        if (!field.value && !custom)
            return [];
        if (!field.value)
            return custom;
        if (!custom)
            return field.value;
        return __spreadArray(__spreadArray([], custom, true), field.value, true);
    };
    var getCustomValues = function () {
        if (!custom)
            return [];
        return custom;
    };
    var getPredefinedValues = function () {
        if (!field.value)
            return [];
        return field.value;
    };
    var onDragEnd = function (result) {
        if (!result.destination) {
            return;
        }
        var items = Array.from(sorted);
        var removed = items.splice(result.source.index, 1)[0];
        items.splice(result.destination.index, 0, removed);
        handleSorted && handleSorted(items);
    };
    // Define sorted values if not defined yet
    useEffect(function () {
        if (sorted && sorted.length)
            return;
        var mappedValues = __spreadArray(__spreadArray([], getPredefinedValues().map(function (item) { return (__assign(__assign({}, item), { linked_id: item.id, is_custom: false })); }), true), getCustomValues().map(function (item) { return (__assign(__assign({}, item), { linked_id: item.id, is_custom: true })); }), true);
        handleSorted && handleSorted(mappedValues);
    }, []);
    return (<>
      <div className="flex w-full flex-col">
        <Label label="Métiers" htmlFor="jobs"/>
        <Instruction instruction="Sélectionnez jusqu’à 3 métiers qui caractérisent votre activité. Réorganisez-les grâce à la fonctionnalité de glisser-déposer !" className="mb-4"/>
        <div className="flex flex-wrap gap-2">
          {getAllValues() && sorted && (<DragDropContext onDragEnd={onDragEnd}>
              <Droppable droppableId="droppable-jobs-flat">
                {function (provided) { return (<div {...provided.droppableProps} ref={provided.innerRef}>
                    {sorted.map(function (item, index) { return (<Draggable key={index} draggableId={"".concat(index)} index={index}>
                        {function (provided, snapshot) { return (<div ref={provided.innerRef} snapshot={snapshot} {...provided.draggableProps} {...provided.dragHandleProps} className="w-fit">
                            <div className="py-1">
                              <MultiSelectFullPill key={index} item={item} disabled={false} onClick={function () { }} selected={false} className="pointer-events-none" sortable={true}>
                                {provided.placeholder}
                              </MultiSelectFullPill>
                            </div>
                          </div>); }}
                      </Draggable>); })}
                    {provided.placeholder}
                  </div>); }}
              </Droppable>
            </DragDropContext>)}
        </div>
        {getAllValues().length ? (<Button type="inline" icon={Edit2} side="start" className="mt-4 self-start text-brand-02" onClick={function () { return setDrawer(true); }}>
            Modifier
          </Button>) : (<Button type="inline" icon={Plus} side="start" className="mt-4 self-start text-brand-02" onClick={function () { return setDrawer(true); }}>
            Ajouter un métier
          </Button>)}
      </div>
      <MultiSelectFull label="Métiers" name="jobs" control={control} categories={categories} title="Métiers" description="Sélectionnez les compétences, expertises et savoir-faire que vous maîtrisez." max={3} open={drawer} handleClose={function () { return setDrawer(false); }} noResults="Vos métiers apparaîtront ici" placeholder="Manager·euse, booker·euse..." custom={custom} handleCustom={function (value) { return handleCustom(value); }} sorted={sorted} handleSorted={function (value) { return handleSorted(value); }} sortingIndicationText="Réorganisez facilement vos métiers grâce à la fonctionnalité de glisser-déposer !" noResultsCustom="Ce métier n'est pas encore disponible sur Majeur·e·s" addCustomText="Ajouter le métier"/>
    </>);
};
export default JobsInput;
